module.exports = __webpack_public_path__ + "img/Logo_ImmoSuccess_Text.73b7529a.png";